import React, { PropTypes } from 'react';
import Toggle from 'material-ui/Toggle';

class InputToggle extends React.Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired
  };

  render() {
    let { label, labelStyle, value, onChange, disabled, labelPosition }  = this.props;

    return (
      <Toggle
        style={{paddingBottom: 16}}
        label={label}
        labelStyle={labelStyle}
        disabled={disabled}
        labelPosition={labelPosition ? labelPosition : 'left'}
        toggled={value}
        onToggle={onChange}
      />
    );
  }
}

InputToggle.defaultProps = {
  value: false
};

export default InputToggle;




// WEBPACK FOOTER //
// ./src/components/form/InputToggle.jsx